/**
 * 保存token信息
 * 1.getItem 查
 * 2.setItem存
 * 3.removeitem删除
*/
export const getItem = name => {
  const value = localStorage.getItem(name)
  if (value === null || value === 'undefined' || value === '') {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}
export const setItem = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}
export const removeitem = name => {
  localStorage.removeItem(name)
}




/**
 * 保存id
 * *
*/

export const getItemId = name => {
  const value = localStorage.getItem(name)
  if (value === null || value === 'undefined' || value === '') {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}
export const setItemId = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}
export const removeitemId = name => {
  localStorage.removeItem(name)
}



// 保存username
export const getUsername = name => {
  const value = localStorage.getItem(name)
  if (value === null || value === 'undefined' || value === '') {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}
export const setUsername = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}
export const removeUsername = name => {
  localStorage.removeItem(name)
}



// 保存登录信息
export const getUser = name => {
  const value = localStorage.getItem(name)
  if (value === null || value === 'undefined' || value === '') {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}
export const setUser = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}
export const removeUser = name => {
  localStorage.removeItem(name)
}









